import React from 'react';
import { PropTypes } from 'prop-types';

import FlashBox from '../../flash-box/flash-box';
import AddProviderModal from './add-provider-modal';
import ProviderIncentiveCostSearch from './provider-incentive-cost-search';

class ProviderIncentiveCost extends React.Component {

  getChildContext() {
    const {
      removeProviderFromIncentive,
      clearIncentiveCost,
      addProviderToIncentive,
      applySearchFilter,
      pickIncentiveCost,
      addManyIncentives,
      startAddManyIncentives,
      finishAddManyIncentives,
      deleteIncentive
    } = this.props;

    return {
      applySearchFilter,
      pickIncentiveCost,
      clearIncentiveCost,
      addProviderToIncentive,
      removeProviderFromIncentive,
      addManyIncentives,
      startAddManyIncentives,
      finishAddManyIncentives,
      deleteIncentive
    };
  }
  renderFlash() {
    const { providerIncentiveCosts: { flashMessage } } = this.props;
    if (flashMessage) {
      setTimeout(() => {
        this.props.flashMessage(undefined);
      }, 10000);
      return (
        <FlashBox message={flashMessage} />
      );
    }
    return null;
  }

  render() {
    const { providerIncentiveCosts, providers } = this.props;
    const { loading, selected } = providerIncentiveCosts;
    const { addingProvider } = providers;
    const isModalOpen = !!selected;

    return (
      <div style={{ width: '100%' }}>
        {this.renderFlash()}
        <h3>Provider Incentives</h3>
        <ProviderIncentiveCostSearch
          providerIncentiveCosts={providerIncentiveCosts}
          loading={loading}
        />
        <AddProviderModal
          isModalOpen={isModalOpen}
          incentiveCost={selected}
          providers={providers.items}
          addingProvider={addingProvider}
        />
      </div>
    );
  }
}
ProviderIncentiveCost.propTypes = {
  applySearchFilter:           PropTypes.func,
  pickIncentiveCost:           PropTypes.func,
  addProviderToIncentive:      PropTypes.func,
  removeProviderFromIncentive: PropTypes.func,
  clearIncentiveCost:          PropTypes.func,
  addManyIncentives:           PropTypes.func,
  startAddManyIncentives:      PropTypes.func,
  finishAddManyIncentives:     PropTypes.func,
  deleteIncentive:             PropTypes.func,
  flashMessage:                PropTypes.func,
  providerIncentiveCosts:      PropTypes.object, //from redux store
  providers:                   PropTypes.object  //from redux store
};

ProviderIncentiveCost.childContextTypes = {
  applySearchFilter:           PropTypes.func,
  pickIncentiveCost:           PropTypes.func,
  addProviderToIncentive:      PropTypes.func,
  removeProviderFromIncentive: PropTypes.func,
  clearIncentiveCost:          PropTypes.func,
  addManyIncentives:           PropTypes.func,
  startAddManyIncentives:      PropTypes.func,
  finishAddManyIncentives:     PropTypes.func,
  deleteIncentive:             PropTypes.func
};

export default ProviderIncentiveCost;
